/**
 * MetricCard Component
 * Reusable KPI display card for dashboards
 */

import { LucideIcon } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface MetricCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  trend?: number;
  trendLabel?: string;
  className?: string;
  iconClassName?: string;
}

export function MetricCard({
  title,
  value,
  icon: Icon,
  trend,
  trendLabel,
  className,
  iconClassName,
}: MetricCardProps) {
  const trendColor = trend && trend > 0 ? 'text-finance-green' : trend && trend < 0 ? 'text-finance-red' : 'text-muted-foreground';

  return (
    <Card className={cn('p-6', className)}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-muted-foreground">{title}</p>
          <p className="mt-2 text-3xl font-bold text-foreground">{value}</p>
          {trend !== undefined && (
            <p className={cn('mt-2 text-sm font-medium', trendColor)}>
              {trend > 0 && '+'}{trend}% {trendLabel || 'vs mês anterior'}
            </p>
          )}
        </div>
        <div className={cn('rounded-full bg-primary/10 p-3', iconClassName)}>
          <Icon className="h-6 w-6 text-primary" />
        </div>
      </div>
    </Card>
  );
}
